var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":_vm.title,"palette":"tints","units":"%"}},[_c('DataGetter',{attrs:{"url":_vm.apiRoute,"params":{
        allYears: true,
        countryISO: _vm.countryISO,
        indicator: _vm.indicator,
        category: 'By technology',
      }},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{attrs:{"data":data,"x-axis-dimension":"year","y-axis-dimension":"techSector","value-dimension":"value"},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('Chart',{attrs:{"options":{
            ..._vm.chartOptions,
            series: [...slicedData]
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((series) => ({ ...series, colorIndex: _vm.techSectorOrder.indexOf(series.name) % 12 })),
          }}})]}}],null,true)})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }